import React, { ReactElement, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Typography } from 'antd'
import { ExpandCollapseChevronButton } from '../../../../../Components/UI'
import { ProposalCardContent } from './ProposalCardContent'
import { s } from './style'
import {
  ProposalCardEventFragment,
  ProposalCardProposalFragment,
} from './ProposalCard.generated-types'
import { ROUTES } from '../../../../../Constants'
import { Link } from 'react-router-dom'

const { Text } = Typography

interface ProposalCardProps {
  event: ProposalCardEventFragment
  proposal: ProposalCardProposalFragment
  expanded?: boolean
  handleExpandCollapse?: () => void
  responseIndex?: number
  refetchEvent?: () => void
  totalEmissionsForAllJourneys?: number | null | undefined
  displayLowestTravelEmissionsBanner?: boolean | undefined
}

export const ProposalCard: FC<ProposalCardProps> = ({
  event,
  proposal,
  expanded = true,
  handleExpandCollapse,
  responseIndex,
  refetchEvent,
  totalEmissionsForAllJourneys,
  displayLowestTravelEmissionsBanner,
}): ReactElement => {
  const { t } = useTranslation()

  const showOtherHead = t('eventHub.inProgress.response.showOtherHead', 'Show')
  const showOtherTail = t(
    'eventHub.inProgress.response.showOtherTail',
    'other responses'
  )

  return (
    <Link
      to={`${ROUTES.PROPOSAL}/${proposal.UUID}`}
      target="_blank"
      rel="noreferrer noopener"
    >
      <div style={{ top: expanded ? 0 : -98 * responseIndex, ...s.wrapper }}>
        <Card
          bodyStyle={s.card}
          style={{ border: 'unset', borderRadius: 'unset', overflow: 'hidden' }}
        >
          {expanded ? (
            <ProposalCardContent
              event={event}
              proposal={proposal}
              totalEmissionsForAllJourneys={
                totalEmissionsForAllJourneys ?? null
              }
              displayLowestTravelEmissionsBanner={
                displayLowestTravelEmissionsBanner ?? null
              }
            />
          ) : (
            <div style={s.collapsed}>
              <ExpandCollapseChevronButton
                expanded={expanded}
                handleExpandCollapse={handleExpandCollapse}
              />
              <Text strong>{`${showOtherHead} ${
                responseIndex + 1
              } ${showOtherTail}`}</Text>
            </div>
          )}
        </Card>
      </div>
    </Link>
  )
}
